module.exports = __webpack_public_path__ + "img/dia_sin_reporte.ebb61b62.svg";